// extracted by mini-css-extract-plugin
export default {"container":"SportsSlider_container--dbL","favoritesLink":"SportsSlider_favoritesLink--s2G"};